import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings"
import {EventType} from "../../../gd/const/event"
import {CALENDAR_COLOR_CONTRAST, CALENDAR_NO_USER_ICON} from "../../../gd-modules/events/const"

const fieldsConfig = {

    'eventTypes': {
        type            : 'value',
        defaultValue    : [
            EventType.COMPANY_HOLIDAY,
            EventType.PROJECT_DEADLINE,
            EventType.PROJECT_MILESTONE,
            EventType.PROJECT_EVENT,
            EventType.PERSONAL_PAID_VACATION,
            EventType.PERSONAL_SICK_LEAVE,
            EventType.TASK_DEADLINE,
            EventType.MEETING
        ],
    },

    'showCalendar': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : true,
    },

    'showOnlyWorkdays': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : false,
    },

    'showWeekNumber': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : false,
    },

    'highlightPastDue': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : true,
    },

    'colorCompanyEvents': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : CALENDAR_COLOR_CONTRAST,
    },

    'colorProjectEventsFieldId': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : 'statusId',
    },

    'projectEventUserIcon': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : CALENDAR_NO_USER_ICON,
    },

    'projectEventIcon': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : true,
    },

    'colorPersonalEvents': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : CALENDAR_COLOR_CONTRAST,
    },

    'personalEventsUserIcon': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : 'i5-none',
    },

    'personalEventIcon': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : true,
    },

    'colorTasksFieldId': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : 'statusId',
    },

    'taskTypeIcon': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : true,
    },

    'taskUserIcon': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : false,
    },

    'colorMeetings': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : CALENDAR_COLOR_CONTRAST,
    },

    'meetingIcon': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : true,
    },
}

export default class UserSettingsViewsMyCalendar extends ServerSettings {

    eventTypes                  : EventType[]
    showCalendar                : boolean
    showOnlyWorkdays            : boolean
    showWeekNumber              : boolean
    highlightPastDue            : boolean

    colorCompanyEvents          : string

    colorProjectEventsFieldId   : ID
    projectEventUserIcon        : string
    projectEventIcon            : boolean

    colorPersonalEvents         : string
    personalEventsUserIcon      : string
    personalEventIcon           : boolean

    colorTasksFieldId           : ID
    taskTypeIcon                : boolean
    taskUserIcon                : boolean

    colorMeetings               : string
    meetingIcon                 : boolean

    constructor(config: any) {

        super(config, fieldsConfig)

        // default event types visible in my calendar
        this.eventTypes                 = this.initValue('eventTypes')
        this.showCalendar               = this.initValue('showCalendar')
        this.showOnlyWorkdays           = this.initValue('showOnlyWorkdays')
        this.showWeekNumber             = this.initValue('showWeekNumber')
        this.highlightPastDue           = this.initValue('highlightPastDue')

        this.colorCompanyEvents         = this.initValue('colorCompanyEvents')

        this.colorProjectEventsFieldId  = this.initValue('colorProjectEventsFieldId')
        this.projectEventUserIcon       = this.initValue('projectEventUserIcon')
        this.projectEventIcon           = this.initValue('projectEventIcon')

        this.colorPersonalEvents        = this.initValue('colorPersonalEvents')
        this.personalEventsUserIcon     = this.initValue('projectEventUserIcon')
        this.personalEventIcon          = this.initValue('projectEventIcon')

        this.colorTasksFieldId          = this.initValue('colorTasksFieldId')
        this.taskTypeIcon               = this.initValue('taskTypeIcon')
        this.taskUserIcon               = this.initValue('taskUserIcon')

        this.colorMeetings              = this.initValue('colorMeetings')
        this.meetingIcon                = this.initValue('meetingIcon')
    }

    toJson() {
        const result = {};

        this.valueToJson(result, 'eventTypes')
        this.valueToJson(result, 'showCalendar')
        this.valueToJson(result, 'showOnlyWorkdays')
        this.valueToJson(result, 'showWeekNumber')
        this.valueToJson(result, 'highlightPastDue')

        this.valueToJson(result, 'colorCompanyEvents')

        this.valueToJson(result, 'colorProjectEventsFieldId')
        this.valueToJson(result, 'projectEventUserIcon')
        this.valueToJson(result, 'projectEventIcon')

        this.valueToJson(result, 'colorPersonalEvents')
        this.valueToJson(result, 'personalEventsUserIcon')
        this.valueToJson(result, 'personalEventIcon')

        this.valueToJson(result, 'colorTasksFieldId')
        this.valueToJson(result, 'taskTypeIcon')
        this.valueToJson(result, 'taskUserIcon')

        this.valueToJson(result, 'colorMeetings')
        this.valueToJson(result, 'meetingIcon')

        return result
    }
}
